const getConfig = () => {
    // For local development
    if (process.env.NODE_ENV === 'development') {
        const bucketName = process.env.REACT_APP_S3_BUCKET_NAME || 'photogallery-media';
        const region = process.env.REACT_APP_AWS_REGION || 'ap-southeast-2';
        return {
            apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001',
            // Local dev reads photos straight from S3
            mediaBaseUrl: `https://${bucketName}.s3.${region}.amazonaws.com`,
            bucketName,
            region
        };
    }

    // For production: same pattern as the Kanban app. CloudFront serves the site,
    // sends /api/* to the backend and serves photos from the private bucket,
    // so everything is on the site's own domain.
    return {
        apiUrl: '',
        mediaBaseUrl: '',
        bucketName: 'photogallery-media',
        region: 'ap-southeast-2'
    };
};

export default getConfig();
